import {useEffect} from 'react'
import {Banner} from '@primer/react'
import {testIdProps} from '@github-ui/test-id-props'
import type {ModelState} from '../../../types'
import {hasReachedMaxOutputTokens} from '../../../utils/model-state'
import {announce} from '@github-ui/aria-live'

interface MaxTokensBannerProps {
  modelState: ModelState
  isBillingEnabled?: boolean
}

const maxTokensReachedMessage = 'You have reached the maximum tokens limit for this output.'

export function MaxTokensBanner({modelState: {isLoading, ...modelState}, isBillingEnabled}: MaxTokensBannerProps) {
  const paidUsageForModel = modelState.catalogData.isBillable && isBillingEnabled
  const showBanner = !isLoading && hasReachedMaxOutputTokens(modelState, !!paidUsageForModel)

  useEffect(() => {
    if (showBanner) announce(maxTokensReachedMessage)
  }, [showBanner])

  if (!showBanner) {
    return null
  }

  return (
    <Banner {...testIdProps('max-tokens-banner')} className="tmp-mb-3" title="Max output tokens reached" hideTitle>
      {maxTokensReachedMessage}
    </Banner>
  )
}
